import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/team-members-icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-7650f3d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dashboard team-theme"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-default-back back-button",
  onclick: "window.history.back()"
}, " Back ", -1))
const _hoisted_4 = { class: "row row-border-bottom" }
const _hoisted_5 = { class: "col-sm-10 col-xs-9 header-col" }
const _hoisted_6 = { class: "header-padding" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2 col-xs-3 image-col" }, [
  /*#__PURE__*/_createElementVNode("img", {
    "data-test": "team-members-icon",
    class: "team-icon",
    src: _imports_0,
    alt: "team members page"
  })
], -1))
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-sm-12" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"80px"} }, null, -1))

import { computed } from "vue";
import { useAxios } from "../../composables/api";
import GroupMemberTable from "../../components/group-member-table/group-member-table.vue";
import { TeamCurrentAndPendingMembersApiModel, TeamSettingsApiModel } from "../../api-models";
import LoadingPage from "../loading-page.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'team-members',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props;

// Fetched data needs to be declared here before any code that is trying to access the variables
const { data: teamSettingsModel } = useAxios<TeamSettingsApiModel>(`/api/teamsettings/${props.id}`);
const { data: currentAndPendingMembers } = useAxios<TeamCurrentAndPendingMembersApiModel>(
  `/api/teammembership/${props.id}`,
);

const canInvite = computed(() => !!teamSettingsModel.value?.userPermissions.canInviteToGroup);
const dataHasLoaded = computed(() => !!teamSettingsModel.value && !!currentAndPendingMembers.value);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (dataHasLoaded.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h2", _hoisted_6, [
                  _createTextVNode(" Members "),
                  (canInvite.value)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        tag: "a",
                        to: `/team/invite/${_ctx.id}`,
                        class: "btn btn-md btn-primary text-center",
                        style: {"margin-left":"20px"},
                        "data-test": "invite-button",
                        event: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Invite")
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _hoisted_7
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(GroupMemberTable, {
                  model: _unref(currentAndPendingMembers),
                  teamId: _ctx.id
                }, null, 8, ["model", "teamId"])
              ])
            ])
          ]),
          _hoisted_11
        ])
      ]))
    : (_openBlock(), _createBlock(LoadingPage, { key: 1 }))
}
}

})